<template>
  <div class="zwsj">
    <img :src="icon" :width="imgW" :height="imgH"/>
    <div class="text">{{ text }}</div>
  </div>
</template>

<script>
  export default {
    name: "Empty",
    props: {
      icon: {
        type: String,
        default: require('@/assets/images/no_data.png')
      },
      text: {
        type: String,
        default: '暂无数据'
      },
      imgW: {
        type: String,
        default: "230px"
      },
      imgH: {
        type: String,
        default: "190px"
      }
    }
  }
</script>

<style lang="scss"  scoped>
  .zwsj {
    padding: 10px 0;
    text-align: center;
    .text {
      color: #999;
      font-size: 12px;
      margin-top: 5px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/empty/src/empty.vue